// Self-contained squawk (SSR transponder) code decoder.
//
// A squawk is a 4-digit octal code (each digit 0-7). A handful of codes are
// reserved worldwide or regionally for special purposes; everything else is a
// discrete code assigned by ATC.

const SPECIAL = {
  "7500": {
    label: "Hijack",
    description: "Unlawful interference — aircraft is being hijacked.",
  },
  "7600": {
    label: "Radio failure",
    description: "Lost communications / radio failure.",
  },
  "7700": {
    label: "General emergency",
    description: "Aircraft is declaring a general emergency.",
  },
  "7777": {
    label: "Military intercept",
    description:
      "Non-discrete code used by military interceptor aircraft (do not use).",
  },
  "0000": {
    label: "Non-discrete / SSR fault",
    description:
      "Non-discrete code — may indicate a transponder or SSR fault. Not normally assigned.",
  },
  "1200": {
    label: "VFR (US)",
    description: "Standard VFR conspicuity code in the United States and Canada.",
  },
  "7000": {
    label: "VFR (Europe)",
    description: "General VFR conspicuity code in Europe (ICAO).",
  },
  "2000": {
    label: "Entry / non-transponder area",
    description:
      "Default code when entering controlled airspace from an area not requiring a transponder.",
  },
  "0030": {
    label: "FIS (UK)",
    description: "Reserved conspicuity code (e.g. UK Flight Information Service).",
  },
  "1201": {
    label: "VFR near glider ops",
    description: "VFR flight in the vicinity of glider operations (US).",
  },
  "7004": {
    label: "Aerobatics",
    description: "Aerobatic / display flying conspicuity code.",
  },
  "7005": {
    label: "High-energy manoeuvres",
    description: "Reserved conspicuity code for high-energy manoeuvres / display flying.",
  },
  "7006": {
    label: "Display / operating area",
    description: "Reserved conspicuity code for display or specific operating areas.",
  },
  "7007": {
    label: "Special operations",
    description: "Reserved conspicuity code for special operations.",
  },
};

const OCTAL_4 = /^[0-7]{4}$/;

/**
 * Decode a 4-digit octal transponder (squawk) code.
 *
 * @param {string|number} code
 * @returns {{code:string, special:boolean, label:string, description:string}|null}
 *   Returns null when the code is not a valid 4-digit octal code.
 */
export function decodeSquawk(code) {
  if (code == null) return null;
  const str = String(code).trim();
  if (!OCTAL_4.test(str)) return null;

  const match = SPECIAL[str];
  if (match) {
    return {
      code: str,
      special: true,
      label: match.label,
      description: match.description,
    };
  }

  return {
    code: str,
    special: false,
    label: "Discrete code",
    description: "Discrete code assigned by ATC.",
  };
}

export default decodeSquawk;
